export default "__VITE_ASSET__0icMo1Xv__"